<template>
    <Modal 
        :show="show"
        class="modal-window"
        :onClose="onClose"
        position="center-right">
        <slot></slot>
    </Modal>
</template>

<script setup>
import Modal from '@/components/ui/Modal';

// Define component options
defineOptions({
    name: 'modal-window'
});

// Define props
defineProps({
    show: { type: Boolean, required: true },
    onClose: { type: Function, default: () => {} }
});
</script>

<style lang="stylus" scoped>
    .modal-window
        padding: 0 8.333333333333334%;
        @media screen and (max-width: 768px) {
            padding 0 15px;
        }
        & :deep(.modal-content)
            width 41.66666666666667%;
            @media (max-width: 1024px) {
                width 80%
            }

            @media (max-width: 768px) {
                width 100%
            }
</style>


